import React from 'react'
import UserIcon from 'components/users/UserIcon'
import useOpenRight from 'refactor/hooks/useOpenRight'
import type { QuestStreamOthersRow as OthersRowData } from 'lib/streamCards'
import styles from './quest-stream-others-row.module.scss'

// The stream card's last line: a face pile of participants not already visible on the
// card + "and N others". People, not a message count — the reply pill keeps the total.
// Tap opens the whole thread. See docs/stream-cards-architecture.md.
export default function QuestStreamOthersRow({
    quest,
    othersRow,
    panelId,
}: {
    quest: any
    othersRow: OthersRowData
    panelId?: string
}) {
    const { openRight } = useOpenRight(panelId)

    const onClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        openRight({ questId: quest?.id })
    }

    return (
        <button
            type="button"
            className={styles.othersRowComp}
            onClick={onClick}
            data-testid="quest-others-row"
        >
            <div className={styles.pile}>
                {othersRow.users.map((user, ix) => (
                    <span className={styles.pileAvatar} key={user?.id ?? ix}>
                        <UserIcon user={user} size="small" />
                    </span>
                ))}
            </div>
            <span className={styles.label}>
                and {othersRow.total} other{othersRow.total === 1 ? '' : 's'}
            </span>
            <span className={styles.arrow}>→</span>
        </button>
    )
}
